module.exports = __webpack_public_path__ + "img/agents_deductions_de-ch.46adac4d.svg";